module.exports = __webpack_public_path__ + "images/emoji/open_file_folder.25d1bdd0a2f5931460e2.png";